import { webSecrets } from './web-secrets'; // generated, git-ignored - see web-secrets.example.ts
/**
 * dev environment setup.
 */
    
    /**
     * prod environment setup.
     */
    export const environment = {
        production: true,
        apiURL: "https://uz62s6frvc.execute-api.eu-west-1.amazonaws.com/prod",
        apiKey: webSecrets.apiKey,
        region: "eu-west-1",
        bucketName: "mps-asset-prod",
        homeUrl: 'https://mps.varuna-sentinels.com/login.html',
        assetsLink: "https://mps-cdn-prod.varuna-sentinels.com/assets/",
        // jasperServerUrl: "http://34.242.193.177:8080/jasperserver/flow.html?_flowId=viewReportFlow&j_username=ihm&j_password=ihm"
        jasperServerUrl: "https://jasperihm.varuna-sentinels.com:8443/jasperserver/flow.html?_flowId=viewReportFlow",
        jasperEnvPrefix: "PROD",
        shipPoSampleFile: "https://ihm-asset-prod.s3-eu-west-1.amazonaws.com/Sample+Format/Sample_Format_Of_Supplier_Ship_PO.xlsx",
        publicKey: webSecrets.publicKey,
        exchangeRate_apiKey: webSecrets.exchangeRateApiKey,
        googleMapsApiKey: webSecrets.googleMapsApiKey
        };